/* eslint-disable */


// Programmatically generated on Mon Apr 27 2026 21:55:40 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'authors_v1',
    'attributes': {
      'email': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'username': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'last_name': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'first_name': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {
      'authored_question_sets_v1': {
        'type': 'one-to-many'
      },
      'authoring_feedback_v1': {
        'type': 'one-to-many'
      },
      'authoring_subjects_v1': {
        'type': 'one-to-many'
      },
      'authoring_supplements_v1': {
        'type': 'one-to-many'
      },
      'owned_question_sets_v1': {
        'type': 'one-to-many'
      },
      'subject_author_permissions_v1': {
        'type': 'one-to-many'
      },
      'user_v1': {
        'type': 'one-to-one'
      },
      'user_v2': {
        'type': 'one-to-one'
      }
    }
  }
);

const ModelRecord = Record(
  {
    'subject_author_permissions': Empty,
    'user': Empty,
    'authoring_feedback': Empty,
    'authoring_subjects': Empty,
    'owned_question_sets': Empty,
    'authoring_supplements': Empty,
    'last_name': Empty,
    'authored_question_sets': Empty,
    'username': Empty,
    'updated_at': Empty,
    'inserted_at': Empty,
    'first_name': Empty,
    'id': Empty,
    'email': Empty,
    'relationshipMeta': Empty,
    'meta': new Map({
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'last_name': '',
    'username': '',
    'first_name': '',
    'id': '',
    'email': '',
    'updated_at': new Date(),
    'inserted_at': new Date(),
    'subject_author_permissions': new List(),
    'authoring_feedback': new List(),
    'authoring_subjects': new List(),
    'owned_question_sets': new List(),
    'authoring_supplements': new List(),
    'authored_question_sets': new List(),
    'meta': new Map(),
    'user': new Map(),
    'relationshipMeta': new Map()
  }
);

export class AuthorModelV1 extends GenericModel(ModelRecord, ModelConfig, 'AuthorModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyAuthorModelV1Model = _emptyAuthorModelV1Model ? _emptyAuthorModelV1Model : new AuthorModelV1(DefaultModel);
    return _emptyAuthorModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'AuthorModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'author_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {string}
   */
  getEmail() {
    const value = this.getValueForAttribute('email');
    return value;
  }

  setEmail(value) {
    return this.setField('email', value);
  }

  /**
   * @type {string}
   */
  getFirstName() {
    const value = this.getValueForAttribute('first_name');
    return value;
  }

  setFirstName(value) {
    return this.setField('first_name', value);
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {string}
   */
  getLastName() {
    const value = this.getValueForAttribute('last_name');
    return value;
  }

  setLastName(value) {
    return this.setField('last_name', value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {string}
   */
  getUsername() {
    const value = this.getValueForAttribute('username');
    return value;
  }

  setUsername(value) {
    return this.setField('username', value);
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
  /**
   * @type {authoring_question_set_v1 (many)}
   */
  getAuthoredQuestionSets() {
    const value = this.getValueForAttribute('authored_question_sets');
    return value;
  }

  // -- Relationship Fields: authored_question_sets --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_feedback_v1 (many)}
   */
  getAuthoringFeedback() {
    const value = this.getValueForAttribute('authoring_feedback');
    return value;
  }

  // -- Relationship Fields: authoring_feedback --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_subject_v1 (many)}
   */
  getAuthoringSubjects() {
    const value = this.getValueForAttribute('authoring_subjects');
    return value;
  }

  // -- Relationship Fields: authoring_subjects --

  /**
   * Adds relationship field getters to the provided object.
   * @private
   */
  __withAuthoringSubjectRelationshipGetters(data) {
    return {
      getCanEditGuideLevels() {
        return data.get('can_edit_guide_levels', null);
      },
      getCanEditSupplements() {
        return data.get('can_edit_supplements', null);
      },
      getCanEditQuestions() {
        return data.get('can_edit_questions', null);
      }
    };
  }

  /**
   * @param {string} [id] - A single relationship to retrieve.
   * @returns {Immutable.List|Immutable.Map}
   */
  getAuthoringSubjectRelationships(id) {
    const data = this.getIn(['relationshipMeta', 'authoring_subject'], new Map());
    if (!id) {
      return data.map((rel) => this.__withAuthoringSubjectRelationshipGetters(rel));
    } else {
      return this.__withAuthoringSubjectRelationshipGetters(data.get(id, new Map()));
    }
  }

  /**
   * @type {authoring_supplement_v1 (many)}
   */
  getAuthoringSupplements() {
    const value = this.getValueForAttribute('authoring_supplements');
    return value;
  }

  // -- Relationship Fields: authoring_supplements --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_question_set_v1 (many)}
   */
  getOwnedQuestionSets() {
    const value = this.getValueForAttribute('owned_question_sets');
    return value;
  }

  // -- Relationship Fields: owned_question_sets --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {subject_author_permission_v1 (many)}
   */
  getSubjectAuthorPermissions() {
    const value = this.getValueForAttribute('subject_author_permissions');
    return value;
  }

  // -- Relationship Fields: subject_author_permissions --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {user_v2 (one)}
   */
  getUser() {
    const value = this.getValueForAttribute('user');
    return value;
  }

  // -- Relationship Fields: user --
  // no 'fields' found, skipped generating accessor(s)
  
}

// -- Empty Model Instance --
let _emptyAuthorModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'email': null,
  'first_name': null,
  'id': null,
  'inserted_at': null,
  'last_name': null,
  'updated_at': null,
  'username': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'authored_question_sets_v1': new Set(['associated']),
  'authoring_feedback_v1': new Set(['associated']),
  'authoring_subjects_v1': new Set(['associated']),
  'authoring_supplements_v1': new Set(['associated']),
  'email': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'first_name': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'last_name': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'meta.populated_metadata_fields': new Set(['null']),
  'owned_question_sets_v1': new Set(['associated']),
  'subject_author_permissions_v1': new Set(['associated']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'user_v1': new Set(['associated']),
  'user_v2': new Set(['associated']),
  'username': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
  },
  required: {
  }
});

// -- Legacy Name Export --
export const Author = AuthorModelV1;
